/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue";
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupHeader from "vux/src/components/popup-header/index.vue";
import Group from "vux/src/components/group/index.vue";
import Checklist from "vux/src/components/checklist/index.vue";
import XAddress from "vux/src/components/x-address/index.vue";
import GaoDeMap from '@/components/GaoDeMap';
import TAddressOnline from '@/components/Base/TAddressOnline';
export default {
  components: {
    Cell: Cell,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupHeader: PopupHeader,
    Checklist: Checklist,
    XAddress: XAddress,
    TAddressOnline: TAddressOnline,
    GaoDeMap: GaoDeMap
  },
  props: {
    beta: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String, Number],
      default: 1
    },
    title: {
      type: String
    },
    defaultAddress: {
      type: String
    },
    defaultLatLong: {
      type: Array
    },
    defaultCode: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isShowMapBtn: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isShowMap: false,
      isShow: false,
      isShowXAddress: false,
      addrType: this.type,
      isGetDefault: false,
      checklist: [],
      areaCode: [],
      areaName: [],
      selected: {
        type: '',
        address: '',
        longitude: '',
        latitude: '',
        code: [],
        name: ''
      }
    };
  },
  computed: {
    // 是否已选择地址
    isUsed: function isUsed() {
      if (this.selected.type && (this.selected.type === 1 || this.selected.type === 2)) {
        if (this.selected.type === 1 && this.selected.longitude && this.selected.latitude) {
          return true; // 存在经纬度
        }

        if (this.selected.type === 2 && this.selected.code.length > 0) {
          return true; // 存在 省市区 code
        }
      }

      return false;
    }
  },
  filters: {
    realAddress: function realAddress(val, selected) {
      if (val === 1) return selected.address;

      if (val === 2) {
        return selected.name ? selected.name.join(' ') : '';
      }
    }
  },
  watch: {
    defaultCode: {
      handler: function handler(val) {
        var _this = this;

        if (val && (val[0] || val[1] || val[2])) {
          this.isGetDefault = true;

          if (this.type === 2) {
            this.addrType = this.type;
            this.selected.type = this.type;
            this.selected.code = this.defaultCode;
            setTimeout(function () {
              _this.selected.name = _this.areaName;
            }, 100);
          }
        }

        if (this.type === 2 && val.length === 0) {
          this.selected = {
            type: 2,
            address: '',
            longitude: '',
            latitude: '',
            code: [],
            name: ''
          };
        }
      },
      immediate: true
    },
    type: {
      handler: function handler(val) {
        this.addrType = val;
        this.selected.type = val;
      },
      immediate: true
    },
    defaultAddress: {
      handler: function handler(val) {
        if (this.type === 1) {
          this.addrType = this.type;
          this.selected.type = this.type;
          this.selected.address = this.defaultAddress || '';
        }
      },
      immediate: true
    },
    defaultLatLong: {
      handler: function handler(val) {
        if (this.type === 1) {
          this.selected.longitude = this.defaultLatLong[0] || '';
          this.selected.latitude = this.defaultLatLong[1] || '';
        }
      }
    }
  },
  methods: {
    callback: function callback(res) {
      this.addrType = 1;
      this.selected.type = this.addrType;
      this.selected.address = res.address;
      this.selected.longitude = res.position[0] + '';
      this.selected.latitude = res.position[1] + '';
      this.$emit('on-change', this.selected);
    },
    showName: function showName(name) {
      this.areaName = name;
      this.selected.name = name;
    },
    onChange: function onChange(code, name) {
      this.addrType = 2;
      this.areaName = name;
      this.areaCode = code;
      this.selected.name = name;
      this.selected.type = this.addrType;
      this.selected.code = this.areaCode;
      this.$emit('on-change', this.selected);
    },
    // 级联滑动 picker 时触发
    // onShadowChange(code, name) {
    //   this.areaCode = code
    //   this.areaName = name
    //   // 外部传入默认值后 更新数据
    //   if (this.isGetDefault) {
    //     this.selected.code = this.areaCode
    //     this.selected.name = this.areaName
    //     this.isGetDefault = false
    //   }
    // },
    // 隐藏级联地址
    // showXAddress() {
    //   setTimeout(() => {
    //     this.isShowXAddress = !this.isShowXAddress
    //   }, 100)
    // },
    // 级联地址 完成按钮触发事件
    // submit(e) {
    //   if (e) {
    //     this.addrType = 2
    //     this.selected.type = this.addrType
    //     this.selected.code = this.areaCode
    //     this.selected.name = this.areaName
    //     this.$emit('on-change', this.selected)
    //   }
    // },
    // 选择地图触发事件
    // selectMapAddress() {
    //   this.isShowXAddress = false
    //   this.$DingTalk &&
    //     this.$DingTalk.biz.map.locate({
    //       onSuccess: res => {
    //         this.addrType = 1
    //         this.selected.type = this.addrType
    //         this.selected.address =
    //           res.province + res.city + res.adName + res.snippet
    //         this.selected.longitude = res.longitude + ''
    //         this.selected.latitude = res.latitude + ''
    //         this.$emit('on-change', this.selected)
    //       },
    //       onFail: e => {
    //         // alert(JSON.stringify(e))
    //         alert('定位失败，请重试')
    //       }
    //     })
    // },
    selectMapAddress: function selectMapAddress() {
      this.isShowMap = true;
      this.isShowXAddress = false;
    }
  },
  created: function created() {}
};